module.exports = __webpack_public_path__ + "static/media/verde.93bc7c14.svg";